// extracted by css-extract-rspack-plugin
export default {"messageMeta":"UserMessageLoading-module__messageMeta__vDYss","messageText":"UserMessageLoading-module__messageText__ylj1b"};